import React from 'react'
import { Layout, Typography, Card, Space, Divider } from 'antd'

const { Content } = Layout
const { Title, Paragraph, Text } = Typography

const AboutUsPage: React.FC = () => {
   return (
      <Layout>
         <Content
            style={{
               maxWidth: 960,
               margin: '0 auto',
               padding: '48px 16px'
            }}
         >
            {/* ===== Header ===== */}
            <Space direction="vertical" size={12} style={{ width: '100%' }}>
               <Title level={2}>Xe ghép Thanh Hóa – Hà Nội</Title>
               <Text strong>Kết nối chuyến đi – Chia sẻ chi phí – Đồng hành cùng nhau</Text>
               <Text type="secondary">Chia sẻ nhiều hơn – Tiết kiệm hơn – Thuận tiện hơn</Text>
            </Space>

            {/* ===== Story ===== */}
            <Card style={{ marginTop: 32 }}>
               <Title level={4}>🌱 Câu chuyện của chúng tôi</Title>

               <Paragraph>
                  Ý tưởng về <Text strong>Xe ghép Thanh Hóa – Hà Nội</Text> bắt đầu từ những chuyến đi rất quen thuộc.
               </Paragraph>

               <Paragraph>
                  Trong những lần di chuyển giữa Thanh Hóa và Hà Nội, chúng tôi nhận ra rằng có rất nhiều xe cá nhân di
                  chuyển mỗi ngày nhưng lại chưa tận dụng hết số ghế trống. Trong khi đó, không ít hành khách phải tốn
                  nhiều chi phí hoặc gặp khó khăn khi tìm chuyến đi phù hợp về thời gian và địa điểm.
               </Paragraph>

               <Paragraph>Từ thực tế đó, chúng tôi tin rằng đi chung xe (carpool) là một giải pháp hợp lý:</Paragraph>

               <ul>
                  <li>Giúp tài xế chia sẻ chi phí xăng xe</li>
                  <li>Giúp hành khách tiết kiệm chi phí di chuyển</li>
                  <li>Giảm số lượng xe lưu thông, góp phần bảo vệ môi trường</li>
               </ul>

               <Paragraph>
                  Và từ mong muốn đơn giản đó, <Text strong>xegheplinhlinh36.com</Text> ra đời.
               </Paragraph>
            </Card>

            {/* ===== What is ===== */}
            <Card style={{ marginTop: 32 }}>
               <Title level={4}>🚗 Xe ghép Thanh Hóa – Hà Nội là gì?</Title>

               <Paragraph>Xe ghép Thanh Hóa – Hà Nội là nền tảng kết nối:</Paragraph>

               <ul>
                  <li>🚘 Tài xế có chuyến đi cố định hoặc linh hoạt</li>
                  <li>🧍‍♂️ Hành khách có nhu cầu di chuyển cùng tuyến</li>
               </ul>

               <Paragraph>
                  Chúng tôi không phải đơn vị vận tải, mà là nền tảng trung gian giúp hai bên dễ dàng tìm thấy nhau,
                  trao đổi thông tin và chủ động thỏa thuận chuyến đi.
               </Paragraph>
            </Card>

            {/* ===== Values ===== */}
            <Card style={{ marginTop: 32 }}>
               <Title level={4}>🤝 Chia sẻ – Tin cậy – Chủ động</Title>

               <Paragraph>Chúng tôi hướng tới một cộng đồng:</Paragraph>

               <ul>
                  <li>Chia sẻ minh bạch: thông tin chuyến đi rõ ràng</li>
                  <li>Tôn trọng lẫn nhau: tài xế và hành khách cùng chủ động, cùng trách nhiệm</li>
                  <li>Linh hoạt: tự do thỏa thuận điểm đón – trả, thời gian, chi phí</li>
               </ul>

               <Paragraph>
                  Mỗi chuyến xe không chỉ là một hành trình, mà còn là sự kết nối giữa những con người có chung tuyến
                  đường.
               </Paragraph>
            </Card>

            {/* ===== Technology ===== */}
            <Card style={{ marginTop: 32 }}>
               <Title level={4}>⚙️ Công nghệ kết nối người dùng</Title>

               <Paragraph>Chúng tôi tập trung xây dựng nền tảng công nghệ:</Paragraph>

               <ul>
                  <li>Giao diện đơn giản – dễ sử dụng</li>
                  <li>Tìm kiếm chuyến đi nhanh chóng</li>
                  <li>Đăng chuyến, đặt chỗ thuận tiện trên điện thoại</li>
               </ul>

               <Paragraph>
                  Mục tiêu của chúng tôi không phải là phức tạp hóa mọi thứ, mà là giúp người dùng tìm được chuyến đi
                  phù hợp chỉ trong vài thao tác.
               </Paragraph>
            </Card>

            {/* ===== Goals ===== */}
            <Card style={{ marginTop: 32 }}>
               <Title level={4}>🎯 Mục tiêu của chúng tôi</Title>

               <ul>
                  <li>Giúp việc đi lại giữa Thanh Hóa – Hà Nội trở nên dễ dàng và tiết kiệm hơn</li>
                  <li>Xây dựng một cộng đồng đi chung xe văn minh</li>
                  <li>Góp phần giảm chi phí, giảm ùn tắc và giảm tác động đến môi trường</li>
               </ul>
            </Card>

            {/* ===== Actions ===== */}
            <Card style={{ marginTop: 32 }}>
               <Title level={4}>🔗 Bạn muốn…</Title>

               <ul>
                  <li>
                     🚗 Tìm chuyến xe phù hợp? → <a href="tel:0922346888">Gọi 092 234 6888</a>
                  </li>
                  <li>
                     🛣 Chia sẻ hành trình của bạn? → <a href="tel:0922346888">Gọi 092 234 6888</a>
                  </li>
                  <li>
                     🤝 Tìm hiểu thêm hoặc hợp tác với chúng tôi? → <a href="tel:0922346888">Gọi 092 234 6888</a>
                  </li>
               </ul>
            </Card>

            {/* ===== Commitment ===== */}
            <Card style={{ marginTop: 32 }}>
               <Title level={4}>📌 Cam kết của chúng tôi</Title>

               <ul>
                  <li>Không thu phí người dùng</li>
                  <li>Không can thiệp vào thỏa thuận tài chính</li>
                  <li>Luôn lắng nghe phản hồi để cải thiện dịch vụ</li>
               </ul>

               <Divider />

               <Paragraph strong>
                  Xe ghép Thanh Hóa – Hà Nội mong muốn trở thành người bạn đồng hành đáng tin cậy trên mỗi chuyến đi của
                  bạn.
               </Paragraph>
            </Card>
         </Content>
      </Layout>
   )
}

export default AboutUsPage
